import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../api/api'
import { STOCK_CONFIG } from "../../view/stock/config";
const initialState = {
    noti: null,
    loading: false,
    error: '',
}
export const notiAsync = createAsyncThunk('noti', async () => {
    try {
        const noti = await api.get(STOCK_CONFIG.requests.getNotify.url)
          if (noti.data.status === true ) {
            return noti.data.result
          }
         
    } catch (error) {
        throw error
    }
})

const notiSlice = createSlice({
    name: 'noti',
    initialState,
    reducers: {
        
    },
    extraReducers: {
        [notiAsync.pending]: (state, action) => {
            state.loading = true
            state.error = ''
        },
        [notiAsync.fulfilled]: (state, action) =>{
            state.noti = action.payload
            state.loading = false
            state.error = ''
        },
        [notiAsync.rejected]: (state, action) => {
            state.noti = null
            state.loading = false
            state.error = action.error.message
        }
    },
})
export default notiSlice.reducer